import { SubProcessResolvedArg } from '@lighthouse/core'
import { ANONYMOUS_PARAM_NAME, type EndFlowNode, type FlowNodeResultADT, generateVariableValue } from '@lighthouse/shared'

import type { ExecuteActionParams } from '../type'

export const handleEndStream = (node: EndFlowNode, params: ExecuteActionParams): Promise<FlowNodeResultADT> => {
    const { config } = node.data
    const { outputArgs } = config || {}
    if (outputArgs && outputArgs.length > 0) {
        const args = outputArgs
            .map(item => {
                const v =
                    item.value !== undefined
                        ? generateVariableValue({ innerType: item.innerType, jsonContent: item.value, extraParams: params })
                        : undefined
                if (v !== undefined) {
                    return {
                        id: item.id,
                        name: item.name || ANONYMOUS_PARAM_NAME,
                        value: v,
                        innerType: item.innerType
                    }
                }
                return undefined
            })
            .filter(Boolean) as SubProcessResolvedArg[]
        return Promise.resolve({
            type: 'args',
            success: true,
            data: args
        })
    }

    return Promise.resolve({
        type: 'args',
        success: true
    })
}
